import { Link } from "react-router-dom";
import { cashCheckout1Event } from "@/utils/dataLayerEvents";
import { useState } from "react";
import {CDN_LINK, PHONE_CONTACT_NUMBER, WHATSAPP_CONTACT_NUMBER} from "@globalConfig";
import LimitedAvaInfoBox  from "./components/LimitedAvaInfoBox/LimitedAvaInfoBox";
import stl from "./LimitedAvaPostViewBtn.module.css";
import { trackEvents } from "@/common/events/events";
import { getNumberWithOutPlus } from "@/utils/GlobalJavascriptFunction";
import {useTranslation} from "@i18n";
import useHelpers from "@hooks/useHelpers";

const LimitedAvaPostViewBtn = ({
  footer_section,
  postId,
  g4_data,
  desktop,
  have_finance = false,
}) => {
  const [showNumbers, setShowNumbers] = useState(false);
  const {t} = useTranslation();
  const {createUrl} =useHelpers();
  return (
    <>
        {desktop && (
        <div className={stl.limitedAvailability} >
          <LimitedAvaInfoBox  />
        </div>
        )}
        {!showNumbers && (
          <div  className={stl.limitedAvailability}>
            <Link
              className={["greenBtn", stl.btn, stl.reserveBtn].join(" ")}
              to={createUrl(
                  have_finance ? `/pre-checkout/${postId}` : `/checkout/shop-apply?postId=${postId}`
              )}
              onClick={() => {
                cashCheckout1Event("limited_availability", g4_data);
              }}
            >
              {footer_section.reserve_btn_text}
            </Link>
            <span
              onClick={() => {
                setShowNumbers(true);
              }}
              className={["greenTextBtn", stl.callUsBtn, stl.btn].join(" ")}
            >
              <img
                className="m-show"
                src={CDN_LINK + "/assets/images/CallGreen.svg"}
                alt="call"
                width={18}
                height={18}
              />
              {t("اتصل بنا للحجز", { ns: "web_post_view" })}
            </span>
          </div>
        )}
      {showNumbers && (
        <div className={stl.callUsBy}>
          <span
            onClick={() => {
              setShowNumbers(false);
            }}
          >
            <img
              src={CDN_LINK + "/assets/bundles/close_search.svg"}
              alt=""
            />
          </span>
          <strong>{t("تواصل معنا عن طريق", { ns: "web_post_view" })}</strong>
          <a
              href={`tel:${PHONE_CONTACT_NUMBER}`}
              className={stl.SOLcallus}
              onClick={() => {
                trackEvents("online_contact", {
                  post_id: postId,
                  contact_type: "call",
                  contact_location: "Car Details",
                });
              }}
          >
            <div>
              <img
                  src={CDN_LINK + "/assets/bundles/Call.svg"}
                  alt=""
              />
              <span>{t("اتصال", {ns: "web_post_view"})}</span>

            </div>
            <div style={{direction: "ltr"}}>
              {getNumberWithOutPlus(PHONE_CONTACT_NUMBER)}
            </div>
          </a>
          <a
              href={`https://api.whatsapp.com/send?phone=${WHATSAPP_CONTACT_NUMBER.substring(1)}&amp;`}
              rel="noopener noreferrer" target="_blank"
            className={stl.SOLwhatus}
            onClick={() => {
              trackEvents("online_contact", {
                post_id: postId,
                contact_type: "whatsapp",
                contact_location: "Car Details",
              });
            }}
          >
            <div>
              <img
                src={CDN_LINK + "/assets/bundles/wpImg.svg"}
                alt=""
                width={24}
                height={24}
              />
              <span>{t("واتساب", { ns: "web_post_view" })}</span>
            </div>
            <div style={{direction: "ltr"}}>
              {getNumberWithOutPlus(WHATSAPP_CONTACT_NUMBER)}
            </div>
          </a>
        </div>
      )}

    </>
  );
};
export default LimitedAvaPostViewBtn;
